export const CARD_DESKTOP_WIDTH = 286;
export const MOBILE_MAP_HEIGHT = "60vh";
export const MOBILE_MAP_HEIGHT_IOS = "50vh";

export const INTERCOM_TOUR_STEPS = {
  filterButton: "intercom-filter-button",
  gamesButton: "intercom-games-button",
  locationInput: "intercom-location-input",
  searchButton: "intercom-search-button",
  searchInput: "intercom-search-input",
  sortButton: "intercom-sort-button",
};
